import { DiscoveryItem } from "src/types/discovery";

export const get_key = (item: DiscoveryItem) => `${item.strategy_id}_${item.blockchain_id}_${item.tokens}_${item.pool_name}`;